import {useCallback} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit, scrollToComponent} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {isLoadingRepricingFormChecker, repricingFormCheckerData} from "../../@signals";
import useRepricingFormData from "./useFormData";


export default function useRepricingCrudDryChecker() {
	const { showToast } = useAppToast()
	const { dataSend } = useRepricingFormData()

	const handlePreview = useCallback(() => {
		isLoadingRepricingFormChecker.value = true
		scrollToComponent("repricing-checker-table")
		return postSubmit(`${BACKEND_APIS.REPRICING}/notifications/preview-rule`, dataSend).then(res => {
			repricingFormCheckerData.value = res
		}).catch(() => showToast.error())
			.finally(() => isLoadingRepricingFormChecker.value = false)
	}, [JSON.stringify(dataSend)])

	return {
		handlePreview
	}
}